<!--<template>
  <nav class="sidebar bg-white dark:bg-gray-800">
    <div class="sidebar-head p-4">
      <router-link to="/" exact>
        <h2
          class="text-2xl font-normal text-gray-800 dark:text-gray-500"
          translate="no"
        >
          زرین
          <span class="text-primary">.</span>
          <span
            class="bg-gray-700 absolute mt-2 dark:block hidden rounded-md py-1 px-2 text-xs text-gray-200"
            >Dark mode</span
          >
        </h2>
      </router-link>
      <button class="lg:hidden block float-right -mt-7" @click="sidebarToggle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="25px"
          height="25px"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 32 32"
        >
          <path
            fill="currentColor"
            d="M7.219 5.781L5.78 7.22L14.563 16L5.78 24.781l1.44 1.439L16 17.437l8.781 8.782l1.438-1.438L17.437 16l8.782-8.781L24.78 5.78L16 14.563z"
          />
        </svg>
      </button>
    </div>
    <div class="sidebar-list p-4" >
      <p class="font-medium p-3 text-gray-400 dark:text-gray-600">منو</p>
      <div class="wrap-item mt-4 dark:text-gray-500">
        <div class="item">
          <router-link
            to="/shop"
            exact
            class="w-full flex text-right rounded-md box-border p-3 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <span class="text-xl">
            </span>
            <span class="w-full"> فروشگاه </span>
          </router-link>
        </div>
        <div class="item">
          <router-link
            to="/menulist"
            exact
            class="w-full flex text-right rounded-md box-border p-3 hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            <span class="text-xl">
            </span>
            <span class="w-full"> منوها</span>
          </router-link>
        </div>
        </div>
    </div>
  </nav>
</template>-->
<style>

</style>
<script>
  //import MenuAccordion from "./MenuAccordion.vue";
  export default {
    components: {
      //MenuAccordion,
    },
    methods: {
      sidebarToggle: function () {
        document.querySelector(".flex-sidebar").classList.add("hidden");
      },
    },
    mounted() {},
  };
</script>
